import { ensureReviewModal } from './review-modal.js';

/**
 * Testimonials — horizontal Splide slider with header prev/next arrows.
 * 3 cards per view on desktop, 2 on tablet, 1 on mobile. The track overflows
 * (slides bleed past the container); the `.testimonials` section clips it.
 * A "show full" button on capped reviews opens the full quote in a modal.
 */
export function testimonialsSlider(Splide) {
  const sliders = document.querySelectorAll('[data-testimonials-slider]');
  if (!sliders.length) return;

  ensureReviewModal();

  sliders.forEach((el) => {
    const splide = new Splide(el, {
      type: 'slide',
      perPage: 3,
      gap: '24px',
      arrows: false,
      pagination: false,
      drag: true,
      speed: 600,
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
      breakpoints: {
        1024: { perPage: 2 },
        640: { perPage: 1 },
      },
    });

    splide.mount();

    const root = el.closest('.testimonials') || el.parentElement;
    const prev = root?.querySelector('[data-slider-prev]');
    const next = root?.querySelector('[data-slider-next]');
    prev?.addEventListener('click', () => splide.go('<'));
    next?.addEventListener('click', () => splide.go('>'));

    const update = () => {
      const end = splide.Components.Controller.getEnd();
      if (prev) prev.disabled = splide.index <= 0;
      if (next) next.disabled = splide.index >= end;
    };
    splide.on('mounted move updated refresh', update);
    update();
  });
}
